<template>
  <div>
    <v-row no-gutters>
      <v-col cols="2" class="text-center" align-self="center">
        <v-icon :color="linkColor" :class="linkMargin" large>
          {{ icon }}
        </v-icon>
      </v-col>
      <v-col cols="10">
        <div v-if="hasCustomerSelected">
          <h6 class="text-uppercase grey--text">
            {{ $t('customer.label.selectedCustomer') }}
          </h6>
          <p class="mb-0">{{ customerName }}</p>
          <p class="grey--text caption">{{ customerCnpj }}</p>
        </div>
        <p v-else class="body-1 grey--text">{{ $t('customer.label.selectCustomer') }}</p>

        <v-divider class="my-5" />

        <div>
          <h6 class="text-uppercase grey--text">
            {{ $t('customer.label.selectedServiceProvider') }}
          </h6>
          <p class="mb-0">{{ serviceProviderName }}</p>
          <p class="grey--text caption">{{ serviceProviderDocument }}</p>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { formatDocument } from '../../../../util/document'

export default {
  name: 'LinkComponent',

  props: {
    customer: {
      type: Object,
      default: null
    },

    serviceProvider: {
      type: Object,
      default: null,
    },

    unlink: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    icon() {
      return this.unlink ? 'mdi-link-variant-remove' : 'mdi-link-variant-plus'
    },

    customerName() {
      return this.customer?.name
    },

    customerCnpj() {
      return formatDocument(this.customer?.cnpj)
    },

    hasCustomerSelected() {
      return this.customer !== null
    },

    linkColor() {
      return this.hasCustomerSelected ? 'secondary' : 'grey lighten-2'
    },

    linkMargin() {
      return this.hasCustomerSelected ? 'mt-1' : 'mt-n15'
    },

    serviceProviderName() {
      return this.serviceProvider ? this.serviceProvider.name : '---'
    },

    serviceProviderDocument() {
      return this.serviceProvider ? formatDocument(this.serviceProvider.document) : '---'
    },
  }
}
</script>
